import React, { useRef } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql } from "gatsby"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Navigation } from "swiper"
import { PrismicLink } from "@prismicio/react"

import "swiper/css"
import "swiper/css/navigation"

export const TestimonialsWithFullImages = ({ slice }) => {
  // console.log("TestimonialsWithFullImages slice: ", slice)

  const swiperRef = useRef(null)

  // Find the index of the item marked as main; default to 0
  const mainIndex = slice.items.findIndex(item => item.is_main === true)
  const initialSlide = mainIndex >= 0 ? mainIndex : 0

  const hasPageLink =
    slice.primary.page_link?.url || slice.primary.page_link?.id

  return (
    <div className="testimonials_with_full_images">
      <section className="twfi-section py-st-2">
        <div className="twfi-swiper-wrapper">
          <Swiper
            ref={swiperRef}
            className="twfi-swiper"
            loop={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            spaceBetween={16}
            grabCursor={true}
            initialSlide={initialSlide}
            modules={[Autoplay, Navigation]}
            navigation={true}
            autoplay={{
              delay: 4500,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
          >
            {slice.items.map((item, index) => {
              const hasItemLink =
                item.item_link?.url || item.item_link?.id

              const cardInner = (
                <div className="twfi-card-inner">
                  {item.image?.gatsbyImageData && (
                    <GatsbyImage
                      className="twfi-image"
                      image={item.image.gatsbyImageData}
                      alt={item.image.alt || ""}
                    />
                  )}
                  <div className="twfi-overlay">
                    <div className="twfi-content">
                      {item.quote && (
                        <p className="twfi-quote">
                          &ldquo;{item.quote}&rdquo;
                        </p>
                      )}
                      <div className="twfi-author">
                        {item.owner_name && (
                          <span className="twfi-owner-name">
                            {item.owner_name}
                          </span>
                        )}
                        {item.shop_name && (
                          <span className="twfi-shop-name">
                            {item.shop_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )

              return (
                <SwiperSlide
                  key={`twfi-slide-${index}`}
                  className="twfi-slide"
                >
                  <div className="twfi-card">
                    {hasItemLink ? (
                      <PrismicLink
                        field={item.item_link}
                        className="twfi-card-link"
                      >
                        {cardInner}
                      </PrismicLink>
                    ) : (
                      cardInner
                    )}
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>

        {hasPageLink && (
          <div className="d-flex justify-content-center mt-4 mt-lg-5">
            <PrismicLink
              field={slice.primary.page_link}
              className="btn-st twfi-page-btn"
            >
              {slice.primary.page_link_label || "See more stories"}
            </PrismicLink>
          </div>
        )}
      </section>
    </div>
  )
}

export const query = graphql`
  fragment HomepageDataBodyTestimonialsWithFullImages on PrismicHomepageDataBodyTestimonialsWithFullImages {
    id
    slice_type
    primary {
      page_link_label
      page_link {
        url
        target
        link_type
        id
        type
        uid
        lang
      }
    }
    items {
      is_main
      image {
        alt
        url
        gatsbyImageData
      }
      quote
      owner_name
      shop_name
      item_link {
        url
        target
        link_type
        id
        type
        uid
        lang
      }
    }
  }

`
